export const getCurrentLanguage = () => {
  return localStorage.getItem('lang') || 'en';
};

export const changeCurrentLanguage = (locale = 'en') => {
  localStorage.setItem('lang', locale);
};
